import {
  Companion_instance289agnsdocyeb as Companion_instance,
  access$_get_origin__hdh1qz8t4atr48tdww as access$_get_origin__hdh1qz,
  CloseToken4utf44psnuyc as CloseToken,
} from './CloseToken.mjs';
import { ClosedByteChannelException3il8gfpye60w as ClosedByteChannelException } from './Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SourceByteReadChannelClass;
function SourceByteReadChannel() {
  if (SourceByteReadChannelClass === VOID) {
    class $ {
      constructor(source) {
        this.y4p_1 = source;
        this.z4p_1 = null;
      }
      t4n() {
        var tmp0_safe_receiver = this.z4p_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
          var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
          var tmp_0;
          if (tmp0_subject == null) {
            tmp_0 = null;
          } else {
            if (isInterface(tmp0_subject, CopyableThrowable())) {
              tmp_0 = access$_get_origin__hdh1qz(tmp0_safe_receiver).q13();
            } else {
              if (tmp0_subject instanceof CancellationException()) {
                tmp_0 = CancellationException().p(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
              } else {
                var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
                tmp_0 = ClosedByteChannelException().x4n(p0);
              }
            }
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      y4n() {
        return this.y4p_1.v3z();
      }
      g4n() {
        var tmp0_safe_receiver = this.t4n();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.y4p_1.u3z();
      }
      *z4n(min, $completion) {
        var tmp0_safe_receiver = this.t4n();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.y4p_1.b40(fromInt(min));
      }
      j4o(cause) {
        if (!(this.z4p_1 == null))
          return Unit_instance;
        this.y4p_1.l6();
        var tmp = this;
        var tmp1_elvis_lhs = cause == null ? null : cause.message;
        tmp.z4p_1 = new (CloseToken())(IOException().g4m(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
      }
    }
    protoOf($).f4o = awaitContent$default;
    initMetadataForClass($, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    SourceByteReadChannelClass = $;
  }
  return SourceByteReadChannelClass;
}
//region block: exports
export {
  SourceByteReadChannel as SourceByteReadChannel1ruj5s0fyiukm,
};
//endregion

//# sourceMappingURL=SourceByteReadChannel.mjs.map
